import SinglePublicationHeader from './SinglePublicationHeader';
export default SinglePublicationHeader;
